'use strict';
const _ = require('underscore');
module.exports = function StoryboardExporter(iconLocaliser, storyboardModel, dimensionProvider) {
	const self = this,
		extractIcons = function (content) {
			const remoteIcons = [];
			_.each(content.storyboard, function (scene) {
				if (scene.image && scene.image.url) {
					remoteIcons.push(scene.image);
				}
			});
			return remoteIcons;
		};

	self.makeExportable = function (callOptions) {
		const scenes = storyboardModel.getScenes(),
			mapped = scenes && {storyboard:
				_.map(scenes, function (scene) {
					return _.extend({title: scene.title}, dimensionProvider.getDimensionsForScene(scene, 800, 600));
				})
			};
		if (_.isEmpty(scenes)) {
			return Promise.reject('empty');
		}
		return iconLocaliser.localiseIcons(mapped, extractIcons, callOptions);
	};
};


